<template>
  <div class="page_box">
     <div class="EVisualizationTitle">
          可视化隐患+社评
          <el-tooltip class="item"
                      style="width: 18px;height: auto;margin-left:10px"
                      effect="light"
                      content="可视化隐患整改+社会化评议"
                      placement="right-start">
            <img src="~@/assets/tishi.png"
                 alt="">.
          </el-tooltip>
        </div>
    <div class="page_option_box    edu_pages_content_box  "
         style="flex-direction:column;height:auto;padding:20px 0;">
      

      <sub-organization style="width: 100%;"
                        @getList="getList"></sub-organization>

    </div>

    <div class="page_table_box"
         style="height:calc( 100% - 184px )">

      <div style="display:flex;margin:12px 0">
        <el-input style="flex:1;margin-left:5px"
                  prefix-icon="el-icon-search"
                  placeholder="请输入学校名称"
                  v-model.trim="reqData.schoolName"
                  size="mini"
                  clearable>
        </el-input>
        <img src="~@/assets/search.png"
             @click="searchData"
             style="width:28px;margin:0 10px;cursor: pointer;"
             alt="">
        <img src="~@/assets/refresh.png"
             @click="searchData"
             style="width:28px;cursor: pointer;"
             alt="">

      </div>
      <div class="school_table_box"
           style="height:85%">
        <el-table :header-cell-style="{ background: '#f5f5f5', color: '#595959' }"
                  :row-style="{color:'#1a1a1a'}"
                  :cell-style="{color:'#1a1a1a'}"
                  :data="tableData"
                  height="100%"
                  class="table_box">
          <el-table-column label="序号"
                           width="70"
                           align="center">
            <template slot-scope="scope">
              {{ reqData.pageSize * (reqData.pageNum - 1) + scope.$index + 1 }}
            </template>
          </el-table-column>

          <el-table-column prop="schoolName"
                           label="学校名称"
                           align="left"
                           width="180"
                           show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="videoName"
                           label="视频主题"
                           align="left"
                           width="180"
                           show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="upUserName"
                           label="上传人"
                           align="left"
                           width="180"
                           show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="videoIntroduce"
                           label="视频介绍"
                           align="left"
                           show-overflow-tooltip>
            <!-- <template v-slot="scope">
              {{ $Common.dateFormatDateTwo(scope.row.startTime) }}
            </template> -->
          </el-table-column>

          <el-table-column prop="videoUpTime"
                           label="上传时间"
                           align="left"
                           width="200"
                           show-overflow-tooltip>
            <template v-slot="scope">
              <span>
                {{ $Common.dateFormatDateTwo(scope.row.videoUpTime) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="100"
                           align="left"
                           fixed="right"
                           show-overflow-tooltip>
            <template v-slot="scope">
              <div style="display:flex;align-items:center;justify-content:space-between;">
                <img src="~@/assets/playbtn.png"
                     @click="previewVideo(scope.row)"
                     style="width: 30px;height: auto;cursor: pointer;"
                     alt="">

              </div>

            </template>
          </el-table-column>

        </el-table>
      </div>
      <div class="pagination_box"
           v-if="total > 0">
        <el-pagination @current-change="handleCurrentChange"
                       
                       :current-page="reqData.pageNum"
                       :page-size="reqData.pageSize"
                       layout=" prev, pager, next"
                       :total="total">
        </el-pagination>
      </div>
    </div>
    <add-edit-dialog :dialogType="dialogType"
                     :addResize="addResize"
                     :dialogInfo="dialogInfo"
                     @searchData="searchData"></add-edit-dialog>
    <el-dialog class="video-dialog"
               :title="videoTitle"
               :visible.sync="dialogVisible"
               :modal-append-to-body="false"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="900px"
               :center="true">
      <ckplayer-only :ckplayerDialogShow="dialogVisible"
                     :isLive="isLive"
                     :videoUrl="videoUrl"
                     :widthHeigt="[900, 494]"></ckplayer-only>
    </el-dialog>
  </div>
</template>

<script>
import Video from 'video.js';
import { Base64 } from 'js-base64';
import AddEditDialog from "./components/indexAddOrEditDialog";
import CkplayerOnly from "@/components/CkplayerOnly";
import subOrganization from "../components/subOrganization";

export default {
  name: "protectList",
  components: {
    AddEditDialog,
    CkplayerOnly,
    subOrganization
  },
  props: {},
  data () {
    return {
      fileUrl: this.$store.state.config.fileUrl,
      reqData: {
        eduId: this.$store.getters.getEduData.eduId,
        pageNum: 1,
        pageSize: 10,
        schoolName: ""
      },
      tableData: [],
      total: 0,
      dialogType: "add",
      addResize: 0,
      dialogInfo: {
        upUserName: "",
        videoName: "",
        videoUrl: "",
        videoIntroduce: "",
        schoolId: this.$store.state.schoolId,
      },
      dialogVisible: false,
      isLive: false,
      videoTitle: "",
      videoUrl: ""
    };
  },
  created () {
    this.getList();
  },
  mounted () { },
  watch: {},
  computed: {
    userInfo () {
      return JSON.parse(sessionStorage.getItem("userInfo"));
    },
    stateList () {
      return [
        { id: 0, name: "全部" },
        { id: 1, name: "已上岗" },
        { id: 2, name: "已下岗" }
      ];
    }
  },
  methods: {
    searchData () {
      this.reqData.pageNum = 1;
      this.getList();
    },
    handleCurrentChange (val) {
      this.reqData.pageNum = val;
      this.getList();
    },
    async getList (data) {
      let req = Object.assign({}, this.reqData);
      if (data) req.eduId = data
      let res = await this.$Http.eduReviewVideoList(req);
      if (res.code == 200) {
        this.tableData = res.data.list;
        this.total = res.data.total;
      } else if (res.code == 101) {
        this.tableData = [];
        this.total = 0;
      } else {
        this.tableData = [];
        this.total = 0;
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    unescape (s) {
      let raw = s;
      return decodeURIComponent(raw).replace(/\+/g, ' ').replace(/\%/g, '%');
    },
    previewVideo (item) {
      this.videoUrl = item.videoUrl;
      // const video = document.getElementById('id' + item.fmId); 
      // console.log(video)
      this.videoTitle = item.videoName;
      this.dialogVisible = true;
    },

    previewFile (fileUrl) {
      let url = Base64.encode(fileUrl);
      window.open('http://150.158.43.79:8012/onlinePreview?url=' + encodeURIComponent(url));
    },
    createClass () {
      this.dialogType = "add";
      this.dialogInfo = {
        upUserName: "",
        videoName: "",
        videoUrl: "",
        videoIntroduce: "",
        schoolId: this.$store.state.schoolId,
      };
      this.addResize++;
    },
    edit (row) {
      this.dialogType = "edit";
      this.dialogInfo = {
        videoId: row.videoId,
        videoName: row.videoName,
        videoUrl: row.videoUrl,
        videoIntroduce: row.videoIntroduce,
        upUserName: row.upUserName,

      };
      this.addResize++;
    },
    del (id) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          // if (dataId >= 1) {
          //   var requestData = {
          //     ids: dataId
          //   };
          // } else {
          //   if (this.delDataList.length < 1) {
          //     this.$message({
          //       type: "error",
          //       message: "请先选择您要删除的数据"
          //     });
          //     return false;
          //   }

          //   var requestData = {
          //     ids: this.delDataList.join(",")
          //   };
          // }
          this.delPrincipalClass(id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    async delPrincipalClass (id) {
      let req = {
        videoId: id
      }
      let res = await this.$Http.delReviewVideo(req, true);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功!"
        });
        this.getList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import '../../../../public/css/edu_pages.scss';

.dialog-content {
  display: flex;
  justify-content: center;
  align-items: center;
}
.dialog-footer {
  text-align: center;
}

.video-dialog {
  /deep/ .el-dialog {
    .el-dialog__body {
      padding: 0;
      #video {
        width: 900px;
        height: 494px;
      }
    }
  }
}
.pagination_box {
  justify-content: flex-end;
}
/deep/ .el-pagination .btn-next,
/deep/ .el-pagination .btn-prev {
  background: transparent !important;
}
/deep/.el-pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
/deep/.el-pager li {
  width: 22px;
  height: 22px;
  min-width: 22px;
  line-height: 22px;
}
/deep/.el-pager li.active {
  color: #fff !important;
  background-color: #575dfb !important;
  border-radius: 2px;
}
.EVisualizationTitle {
  font-size: 20px;
  font-weight: 600;
  line-height: 22px;
  display: flex;
  margin: 10px 0  15px 0 ;
  align-items: center;
  /* 按钮底部-191919 */
  color: #191919;
}
</style>
